import React from 'react'
import { Card } from 'antd'

import l1 from '../../../../assets/ui-layout/1.png'
import l2 from '../../../../assets/ui-layout/2.png'
import l3 from '../../../../assets/ui-layout/3.png'
import l4 from '../../../../assets/ui-layout/4.png'
import l5 from '../../../../assets/ui-layout/5.png'
import l6 from '../../../../assets/ui-layout/6.png'
import l7 from '../../../../assets/ui-layout/7.png'
import l8 from '../../../../assets/ui-layout/8.png'
import l9 from '../../../../assets/ui-layout/9.png'
import l10 from '../../../../assets/ui-layout/10.png'
import l11 from '../../../../assets/ui-layout/11.jpg'

const layouts = [
    { id: 1, img: l3 },
    { id: 2, img: l2 },
    { id: 3, img: l1 },
    { id: 4, img: l4 },
    { id: 5, img: l5 },
    { id: 6, img: l6 },
    { id: 7, img: l7 },
    { id: 8, img: l8 },
    { id: 9, img: l9 },
    { id: 10, img: l10 },
    { id: 11, img: l11 },
]

const UILayout = ({ onSelect }) => {
    return (
        <div>

            {layouts.map((item) => (
                <Card
                    size='small'
                    key={item.id}
                    hoverable
                    style={{ marginBottom: 12 }}
                    bodyStyle={{ padding: 8 }}
                    onClick={() => onSelect?.(item.id)}
                >
                    <img
                        src={item.img}
                        alt={`Layout ${item.id}`}
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            borderRadius: 4,
                        }}
                    />
                </Card>
            ))}
        </div>
    )
}

export default UILayout
